// extracted by mini-css-extract-plugin
module.exports = {"root":"IiKU07","header":"RwSfDh","content":"neU9ON","body":"rnIWe3","seeMore":"G6hFZT"};